(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/shuffle', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/shuffle'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.shuffle, global.convert);
    global.shuffle = mod.exports;
  }
})(this, function (exports, _shuffle2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.shuffle = undefined;

  var _shuffle3 = _interopRequireDefault(_shuffle2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of shuffled elements.
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#shuffle|lodash.shuffle} for more information.
   * @example shuffle({ nested: { prop: [1, 2, 3, 4, 5, 6, 7, 8, 9] } }, 'nested.prop') // => { nested: { prop: [7, 3, 9, 1, 4, 5, 6, 8, 2] } }
   * @since 0.3.0
   */
  var shuffle = (0, _convert.convert)(_shuffle3.default);
  exports.shuffle = shuffle;
  exports.default = shuffle;
});